import { Modal } from 'reactstrap';

const ReserveBalanceInfoModal = ({
    isOpen,
    toggle
}) => {
    return (
        <Modal
            isOpen={isOpen}
            centered
            className="cm_g_modal_wrapper"
        >
            <div className='cm_g_modal_header'>
                <h3>Reserve</h3>
                <span onClick={toggle}>
                    <i className='fa-solid fa-xmark'></i>
                </span>
            </div>

            <div className='cm_g_modal_body'>
                <div className='cm_inner_modal_scroll_div'>
                    <div className='d-flex gap-3 mb-3 cm_inner_modal_scroll_div'>
                        <div>
                            <span className='bg_icon_g color_yellow'>
                                <i className='fa-solid fa-shield-halved'></i>
                            </span>
                        </div>
                        <div className='w-full'>
                            <p>To reduce chargebacks and protect your earnings, Juicy House temporarily holds 5% of each transaction in a reserve for 30 days.</p>
                        </div>
                    </div>


                    <div className="mb-4 gray_dot_pos">
                        <div className="d-flex gap-3">
                            <div className="gray_dot"></div>
                            <div className='w-full'>
                                <p>Funds are added automatically as you earn</p>
                            </div>
                        </div>
                        <div className="d-flex gap-3">
                            <div className="gray_dot"></div>
                            <div className='w-full'>
                                <p>Any refunds or chargebacks during this period are covered from the reserve</p>
                            </div>
                        </div>
                        <div className="d-flex gap-3">
                            <div className="gray_dot"></div>
                            <div className='w-full'>
                                <p>After 30 days, unused funds are automatically released to your Available balance</p>
                            </div>
                        </div>
                    </div>


                    <div class="bb_card">
                        <h4>Example:</h4>
                        <p>
                            5% reserved from earnings on the 1st will be released on the 30th.
                        </p>
                    </div>


                    <div class="bb_card">
                        <h4>Chargebacks:</h4>
                        <p>
                            If a chargeback occurs, the chargeback amount plus a $20 processing fee is deducted from your reserve. If the reserve balance is insufficient, the remaining amount will be deducted from future earnings.
                        </p>
                    </div>

                </div>

                <span
                    onClick={toggle}
                    className='btn btn_primary w-full mt-3'
                >
                    Got it
                </span>
            </div>
        </Modal>
    );
};

export default ReserveBalanceInfoModal;

